import { Button, Card, Col, Descriptions, Form, Input, Modal, notification, Popconfirm, Row } from 'antd';
import React, { useState } from 'react';
import { CustomSelector } from '../../../components';
import { ajaxTablePersons as filterPerson, getCharges } from '../../../api/module/project_person';
import Title from 'antd/lib/typography/Title';
import AjaxTable from '../../../components/AjaxTable';
import { SearchOutlined } from '@ant-design/icons';
import { createUnitPersonMassive } from '../../../api/module/unit_person';
import MESSAGES from '../../../enums/Messages';


export default function BindPeopleToUnits({ project, parentModalBindPeople, responseBindPeople, units = []}) {
  const [formSearchPeople] = Form.useForm();
  const [modalBindPeople, setModalBindPeople] = useState(true);
  const [loading, setLoading] = useState(false);
  const [reloadPerson, setReloadPerson] = useState(false);
  const [queryPersons, setQueryPersons] = useState("filter[proyecto]="+project);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const columnsPerson = [
    {
      title: 'Nombre completo',
      dataIndex: 'nombre_completo',
      key: 'nombre_completo',
    },
    {
      title: 'Documento identificación',
      dataIndex: 'numero_identificacion',
      key: 'numero_identificacion',
    },
    {
      title: 'Perfil asignado',
      dataIndex: 'perfil_nombre',
      key: 'perfil_nombre',
    },
    {
      title: 'Contrato vinculado',
      dataIndex: 'contrato_nombre',
      key: 'contrato_nombre',
    },
    {
      title: 'Cargo contrato',
      dataIndex: 'cargo',
      key: 'cargo',
    },
    {
      title: 'País',
      dataIndex: 'notificacion_pais',
      key: 'notificacion_pais',
    },
    {
      title: 'Departamento',
      dataIndex: 'notificacion_ciudad',
      key: 'notificacion_ciudad',
    },
    {
      title: 'Municipio',
      dataIndex: 'notificacion_estado',
      key: 'notificacion_estado',
    },
  ];

  const handleReset = () => {
    formSearchPeople.resetFields();
    setModalBindPeople(false);
    setSelectedRowKeys([]);
    parentModalBindPeople(false);
  };

  const searchPeople = async (values) => {
    let params = Object.entries(values).filter(([_, value]) => value !== undefined)
      .reduce((pv, cv) => {
        pv[`filter[${cv[0]}]`] = cv[1];
        return pv;
      },{});
    params['filter[proyecto]'] = project;
    const query = new URLSearchParams(params).toString();
    setQueryPersons(query);
  };

  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const bindUnitsPersons = async () => {
    if (selectedRowKeys.length > 0) {
      try {
        let data = [];
        units.forEach(u => {
          selectedRowKeys.forEach(p => {
            data.push({ "persona": p, "unidad": u, "proyecto": project });
          });
        });
        await createUnitPersonMassive(data);
        notification.success({
          message: MESSAGES.SUCCESS_MSG,
          description: MESSAGES.DESC_SUCCESS_MSG,
          duration: 3,
        });
      } catch (error) {
        console.log(error);
        notification.error({
          message: MESSAGES.ERROR_MSG,
          description: MESSAGES.DESC_ERROR_POST_MSG,
          duration: 3,
        });
      } finally {
        handleReset();
        responseBindPeople();
      }
    } else {
      notification.warning({
        message: "Persona Requerida",
        description: "Debe seleccionar al menos una persona para poder asignar a unidades.",
        duration: 3,
      });
    }
  };

  return (
    <Modal
      title='Vincular Personas a Unidades'
      open={modalBindPeople}
      onCancel={handleReset}
      footer={null}
      width={'70%'}
      destroyOnClose
    >
      <Row style={{ marginTop: '20px' }}>
        <Col span={24}>
          <Descriptions
            column={1}
            bordered
            size="small"
          >
            <Descriptions.Item label="Unidades Seleccionadas:">
              {units.length}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form
            form={formSearchPeople}
            name="project_person_search_form"
            layout="vertical"
            onFinish={searchPeople}
          >
            <Card
              variant='borderless'
              title={<Title level={5}>Búsqueda de personas</Title>}
            >
              <Row justify={'space-around'}>
                <Col span={8}>
                  <Form.Item label="Nombre y apellidos" name="nombre_completo">
                    <Input allowClear placeholder="Búsqueda por nombre" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Documento" name="numero_identificacion">
                    <Input
                      type="number"
                      allowClear
                      placeholder="Búsqueda por documento"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Correo electrónico" name="notificacion_email">
                    <Input
                      allowClear
                      type={'email'}
                      placeholder="Búsqueda por correo electrónico"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify={'space-around'}>
                <Col span={24}>
                  <Form.Item label="Cargo:"  name="cargo">
                    <CustomSelector
                      selectorProps={{
                        style: { width: '100%' },
                        placeholder: 'Seleccione el cargo contrato... ',
                      }}
                      endpointFetch={async () => {
                        return await getCharges(project);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify={'space-around'}>
                <Col span={8}>
                  <Form.Item label="País residencia" name="notificacion_pais">
                    <Input allowClear placeholder="Búsqueda por país" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Departamento residencia" name="notificacion_estado">
                    <Input
                      allowClear
                      placeholder="Búsqueda por departamento"
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Municipio de residencia" name="notificacion_ciudad">
                    <Input
                      allowClear
                      placeholder="Búsqueda por municipio"
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row justify={'center'}>
                <Col span={24}>
                  <Form.Item>
                    <Button
                      type="primary"
                      icon={<SearchOutlined />}
                      htmlType="submit"
                      loading={loading}>
                      Buscar</Button>
                    <Button
                      style={{ marginLeft: '20px' }}
                      danger
                      onClick={() => {
                        formSearchPeople.resetFields();
                        setQueryPersons("filter[proyecto]="+project);
                      }}>
                      Borrar filtros</Button>
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Form>
        </Col>
      </Row>
      <Row style={{ marginTop: '10px' }}>
        <Col span={24}>
          <AjaxTable
            tableTitle={'Listado de contratistas asignados al proyecto'}
            rowKey={'id'}
            rowSelection={rowSelection}
            endpoint={filterPerson}
            query={queryPersons}
            columns={columnsPerson}
            searchInput={true}
            reloadSource={reloadPerson}
          />
        </Col>
      </Row>
      <Row style={{ marginTop: '15px' }} justify={'center'}>
        <Col>
          <Popconfirm
            title='Confirmación de asignación'
            description={`Se asignaran ${selectedRowKeys.length} personas a ${units.length} unidades. Esta Seguro(a) de continuar ?`}
            onConfirm={bindUnitsPersons}
            okText='Confirmar'
            cancelText='Cancelar'
          >
            <Button type="primary">
              Vincular personas seleccionadas a unidades
            </Button>
          </Popconfirm>
        </Col>
        <Col style={{ marginLeft: '20px' }}>
          <Button
            onClick={() => handleReset()}
            danger
          >Volver</Button>
        </Col>
      </Row>
    </Modal>
  )
};
